import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { MatDialogRef, MatDialog } from '@angular/material';
import { user } from '../classes/userInGroup';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator } from '@angular/material';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import { TabsDataService} from '../shared/services/tabs-data.service';
import { DefineAreaModalComponent } from "../define-area-modal/define-area-modal.component";

@Component({
  selector: 'app-manage-group-dialog',
  templateUrl: './manage-group-dialog.component.html',
  styleUrls: ['./manage-group-dialog.component.css']
})

export class ManageGroupDialogComponent implements OnInit {
  surveyNames: any[];
  "teamName": string;
  "qIDs": string[];
  qNames: string[];
  "description": string[];
  "createdAt": string;
  public "uIDs": user[];
  list: boolean;
  manageGroupDatabase: ManageGroupDatabase;
  manageSurveyDatabase: ManageSurveyDatabase;
  dataSource: ManageGroupDataSource | null;
  SurveysdataSource: ManageSurveyDataSource | null;

  displayedColumns = ['Name', 'Username', 'addedOn','action'];
  displayedSurveysColumns = ['Name', 'addedOn','status' , 'action' ,'areaDefine'];
  failMsg: string;
  Msg: string;
  addedOn: any;
  editNameflag: boolean;

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('otherPaginator') otherPaginator: MatPaginator;

  viewType : "manage"|"viewSurvey"|"viewSurveyor";
  surveyorList: {surveyor:string,addedOn:string}[]=[];
  displayedColumns2: string[] = [ 'surveyor', 'addedOn'];
  surveyList: {survey:string,assignedOn:string}[]=[];
  displayedColumns3: string[] = [ 'survey', 'assignedOn'];
  teams:{id:string,qIds:string[],teamName:string}[] = [];
  teamName_;
  currentTeamId;
  teamAdminId:string;
  constructor(private dialog:MatDialog, private restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any, public manageGroupDialogRef: MatDialogRef<ManageGroupDialogComponent>,private toastyService:ToastyService, private tabsDataService:TabsDataService) {
    this.surveyNames = [];
    this.manageGroupDatabase = new ManageGroupDatabase(this.restApiService, this.data.id);
    this.manageSurveyDatabase = new ManageSurveyDatabase(this.restApiService, this.data.qIDs,this.data.id);
    this.viewType = data.view;
    if(data){
      this.teamName_ = data.teamName;
    }
    if(data.adminID){
      this.teamAdminId = data.adminID;
    }

    this.currentTeamId = this.data.id;
    // getting list of survey
    if(this.viewType == 'viewSurvey'){
      const qIDs = this.data.qIDs;
      this.teams = this.data.teams;
      for (let index = 0; index < this.teams.length; index++) {
        if(this.teams[index].id == this.currentTeamId){
          this.currentIndex = index;
          break;
        }
      }
      this.restApiService.requestAdminSurveys(this.data.id).subscribe(
        result => {
          // console.log(result);
          if(result && result.success && result.result){
            let data= result.result;
            this.surveyList = [];
            data.forEach(data=>{
              if(qIDs.includes(data.qID)){
                const createdOn = data.createdAt?data.createdAt.substring(0,10):'';
                this.surveyList.push({survey:data.surveyName, assignedOn:createdOn});
              }
            })
          }
        });
    }

    // getting list of surveyor
    if(this.viewType == 'viewSurveyor'){
      this.teams = this.data.teams;
      for (let index = 0; index < this.teams.length; index++) {
        if(this.teams[index].id == this.currentTeamId){
          this.currentIndex = index;
          break;
        }
      }
      this.restApiService.getListOfSurveyorsForTeam(this.data.id).subscribe(
        result => {
          // console.log(result);
          if(result && result.success && result.result){
            let data= result.result;
            this.surveyorList = [];
            data.forEach(data=>{
              const createdOn = data.createdAt?data.createdAt.substring(0,10):'';
              this.surveyorList.push({surveyor:data.Name, addedOn:createdOn});
            })
          }
        });
    }
  }

  ngOnInit() {
    if(this.viewType == "manage"){
      this.dataSource = new ManageGroupDataSource(this.manageGroupDatabase, this.otherPaginator);
      this.SurveysdataSource = new ManageSurveyDataSource(this.manageSurveyDatabase, this.paginator);
      this.teamName = this.data.teamName;
      this.qIDs = this.data.qIDs;
      this.qNames = this.data.qNames;
      this.editNameflag = false;
      this.list = this.data.list;
      this.createdAt = this.data.createdAt;
      if (this.data.uIDs) {
        this.uIDs = this.data.uIDs;
      }
      else
        this.uIDs = [];
      this.addedOn = [];
    }
  }

  currentIndex = 0;
  showPrevious(){
    for (let index = 0; index < this.teams.length; index++) {
      if(this.teams[index].id == this.currentTeamId && index !=0){
        this.currentTeamId = this.teams[index-1].id;
        this.currentIndex = index-1;
        this.teamName_ = this.teams[index-1].teamName;
        this.getDataToPreview();
        break;
      }
    }
  }

  showNext(){
    for (let index = 0; index < this.teams.length; index++) {
      if(this.teams[index].id == this.currentTeamId && index != this.teams.length-1){
        this.currentTeamId = this.teams[index+1].id;
        this.currentIndex = index+1;
        this.getDataToPreview();
        this.teamName_ = this.teams[index+1].teamName;
        break;
      }
    }
  }

  addSurveyor(){
    let response = {addSurveyor : true, index : this.currentIndex};
    this.manageGroupDialogRef.close(response);
  }

  assignSurvey(){
    let response = {assignSurvey : true, index : this.currentIndex};
    this.manageGroupDialogRef.close(response);
  }

  getDataToPreview(){
    // getting list of survey
    if(this.viewType == 'viewSurvey'){
      const qIDs = this.teams[this.currentIndex].qIds;
      this.restApiService.requestAdminSurveys(this.currentTeamId).subscribe(
        result => {
          // console.log(result);
          if(result && result.success && result.result){
            let data= result.result;
            this.surveyList = [];
            data.forEach(data=>{
              if(qIDs.includes(data.qID)){
                const createdOn = data.createdAt?data.createdAt.substring(0,10):'';
                this.surveyList.push({survey:data.surveyName, assignedOn:createdOn});
              }
            })
          }
        });
    }

    // getting list of surveyor
    if(this.viewType == 'viewSurveyor'){
      this.restApiService.getListOfSurveyorsForTeam(this.currentTeamId).subscribe(
        result => {
          // console.log(result);
          if(result && result.success && result.result){
            let data= result.result;
            this.surveyorList = [];
            data.forEach(data=>{
              const createdOn = data.createdAt?data.createdAt.substring(0,10):'';
              this.surveyorList.push({surveyor:data.Name, addedOn:createdOn});
            })
          }
        });
    }
  }

  editName() {
    this.editNameflag = true;
  }

  onCancel() {
    this.manageGroupDialogRef.close({
      success: false
    });
  }
  namechange() {
    if (this.editNameflag == true) {
      this.restApiService.editName(this.teamName, this.data.id).subscribe(result => {
      });
    }
    this.editNameflag = false;
  }
  namereset() {
    this.editNameflag = false;
    this.teamName = this.data.teamName;
  }
  listOfsurveys() {
    this.list = false;
  }
  listOfusers() {
    this.list = true;
  }
  deleteSurvey(deleteSurveyID) {
    if (deleteSurveyID > -1) {
      this.qNames.splice(deleteSurveyID, 1);
    }
  }

  defineAreaForSurvey(row){
    row.teamName = this.teamName;
    if(row.action == "Assigned")
    {
      row.teamID = this.data.id;
      let dialogRef = this.dialog.open(DefineAreaModalComponent, {
        height: '600px',
        width: '88rem',
        data: row
      })
      dialogRef.afterClosed().subscribe(result=>{
        row.defined_area = result.count;
        // console.log(result);
      })
    }
  }
  actionSurveyor(row) {
    if (row.action != "Assigned") {
      this.uIDs.push(row.uID);
    }
    else {
      let index = this.uIDs.indexOf(row.uID);
      if (index != -1) {
        this.uIDs.splice(index, 1);
      }
    }
    // do not assign or unassign team if qID is null..
    if(this.qIDs.includes(null)|| this.qIDs.includes(undefined) || this.qIDs.includes('undefined')){
      console.log("qIDs must not have null values.");
      return;
    }
    this.restApiService.assignSurveysToGroupService(this.uIDs, this.teamName, this.qNames, this.qIDs
      ,this.teamAdminId).subscribe(
      result => {
        if (result.success != false) {

          if(row.action != "Assigned")
          {
            row.action = 'Assigned';
            row.src = '../../assets/images/selectedTeam.svg';
          }
          else {
            row.action = 'Unassigned';
            row.src = '../../assets/images/selectTeam.svg';
          }
          this.tabsDataService.setTeamsTabDataTobeUpdated(true);
          this.tabsDataService.setSurveyTabDataTobeUpdated(true);
          this.addToast(row.Name,row.action,'Surveyor');
        }
        else {
          this.failMsg = result.msg;
        }
      });
  }

  actionSurvey(row) {
    if (row.action != "Assigned") {
      this.qNames.push(row.surveyName);
      this.qIDs.push(row.qID);
    }
    else {
      let index = this.qNames.indexOf(row.surveyName);
      if (index != -1) {
        this.qNames.splice(index, 1);
        this.qIDs.splice(index, 1);
      }
    }
    // do not assign or unassign team if qID is null..
    if(this.qIDs.includes(null)|| this.qIDs.includes(undefined) || this.qIDs.includes('undefined')){
      console.log("qIDs must not have null values.");
      return;
    }
    this.restApiService.assignSurveysToGroupService(this.uIDs, this.teamName, this.qNames, this.qIDs,
      this.teamAdminId).subscribe(
      result => {
        if (result.success != false) {
          if(row.action != "Assigned")
          {
            row.action = 'Assigned';
            row.src = '../../assets/images/selectedTeam.svg';
          }
          else {
            row.action = 'Unassigned';
            row.src = '../../assets/images/selectTeam.svg';
          }
          this.tabsDataService.setTeamsTabDataTobeUpdated(true);
          this.tabsDataService.setSurveyTabDataTobeUpdated(true);
          this.addToast(row.surveyName,row.action,'Survey');
        }
        else {
          console.log("fail" + result.msg);
          this.failMsg = result.msg;
        }
      });
  }

  getNumSurveyers(row) {
    let num = 0;
    let users = row.uIDs;
    if (users != null) {
      num = row.uIDs.length;
    }
    return num;
  }
  addToast(name,action,actionOn) {
    if(action=='Unassigned'){
      let toastOptions:ToastOptions = {
        title: action,
        msg: name + '( '+ actionOn + ') was successfully removed from the team' ,
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.warning(toastOptions);
    }else if(action=='Assigned'){
      let toastOptions:ToastOptions = {
        title: action,
        msg: name + '( '+ actionOn + ') was successfully added to the team' ,
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.success(toastOptions);
    }
  }
}


export interface ManageGroupDetail {

  "adminIDs": string,
  "Name": string
  "createdAt": string,
  "status": string,
  "action": string,
  "src": string
}

export class ManageGroupDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<ManageGroupDetail[]> = new BehaviorSubject<ManageGroupDetail[]>([]);
  restApiService: RestApiService;
  get data(): ManageGroupDetail[] { return this.dataChange.value; }

  constructor(restApiService: RestApiService, teamID) {
    this.restApiService = restApiService;
    this.restApiService.getListOfSurveyorsForTeam(teamID).subscribe(
      result => {
        // console.log(result);
        for (let i = 0; i < result.result.length; i++) {
          this.addUserinTeam(result.result[i]);
        }
      });

    this.restApiService.getListOfSurveyorsNotInTeam(teamID).subscribe(
      result => {
        // console.log(result);
        for (let i = 0; i < result.result.length; i++) {
          // this.teamID.push(result.result.rows[i]);
          this.addUser(result.result[i]);
        }
      });
  }

  /** Adds a new user to the database. */
  addUserinTeam(user) {
    const copiedData = this.data.slice();
    copiedData.push(this.createuserinTeam(user));
    this.dataChange.next(copiedData);
  }

  /** Builds and returns a new User. */
  private createuserinTeam(user) {
    user['action'] = 'Assigned';
    user['src'] = '../../assets/images/selectedTeam.svg';
    return user;
  }
  /** Adds a new user to the database. */
  addUser(user) {
    const copiedData = this.data.slice();
    copiedData.push(this.createNewGroup(user));
    this.dataChange.next(copiedData);
  }

  /** Builds and returns a new User. */
  private createNewGroup(user) {
    user['action'] = 'Unassigned';
    user['src'] = '../../assets/images/selectTeam.svg';
    return user;
  }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class ManageGroupDataSource extends DataSource<any> {
  constructor(private _exampleDatabase: ManageGroupDatabase, private _otherpaginator: MatPaginator) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<ManageGroupDetail[]> {
    const displayDataChanges = [
      this._exampleDatabase.dataChange,
      this._otherpaginator.page,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._exampleDatabase.data.slice();

      // Grab the page's slice of data.
      const startIndex = this._otherpaginator.pageIndex * this._otherpaginator.pageSize;
      return data.splice(startIndex, this._otherpaginator.pageSize);
    });
  }

  disconnect() { }
}

export interface ManageSurveysDetail {

  "adminIDs": string,
  "Name": string
  "createdAt": string,
  "status": string
}

export class ManageSurveyDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<ManageSurveysDetail[]> = new BehaviorSubject<ManageGroupDetail[]>([]);
  restApiService: RestApiService;
  get data(): ManageSurveysDetail[] { return this.dataChange.value; }

  constructor(restApiService: RestApiService, qIDs, teamID) {
    this.restApiService = restApiService;

    this.restApiService.requestAdminSurveys(teamID).subscribe(
      result => {
        // console.log(result);
        let surveyAssigned: boolean;
        for (let i = 0; i < result.result.length; i++) {
          surveyAssigned = false;
          for (let j = 0; j < qIDs.length; j++) {
            if (qIDs[j] == result.result[i].qID) {
              this.addSurvey(result.result[i]);
              surveyAssigned = true;
              break;
            }
          }
          if (surveyAssigned == false) {
            this.addNewSurvey(result.result[i]);
          }
        }
      });

  }

  /** Adds a new survey to the database. */
  addSurvey(survey) {
    const copiedData = this.data.slice();
    copiedData.push(this.createsurvey(survey));
    this.dataChange.next(copiedData);
  }

  /** Builds and returns a new survey. */
  private createsurvey(survey) {
    survey['action'] = 'Assigned';
    survey['src'] = '../../assets/images/selectedTeam.svg';
    if (survey['status'] == 'p') {
      survey['status'] =  'Published';
    }
    else {
      survey['status'] =  'Draft';
    }
    return survey;
  }
  /** Adds a new survey to the database. */
  addNewSurvey(survey) {
    const copiedData = this.data.slice();
    copiedData.push(this.createNewSurvey(survey));
    this.dataChange.next(copiedData);
  }

  /** Builds and returns a new survey. */
  private createNewSurvey(survey) {    
    survey['action'] = 'Unassigned';
    survey['src'] = '../../assets/images/selectTeam.svg';
    if (survey['status'] == 'p') {
      survey['status'] =  'Published';
    }
    else {
      survey['status'] =  'Draft';
    }
    return survey;
  }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class ManageSurveyDataSource extends DataSource<any> {
  constructor(private _exampleDatabase: ManageSurveyDatabase, private paginator: MatPaginator) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<ManageSurveysDetail[]> {
    const displayDataChanges = [
      this._exampleDatabase.dataChange,
      this.paginator.page,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._exampleDatabase.data.slice();

      // Grab the page's slice of data.
      const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
      return data.splice(startIndex, this.paginator.pageSize);
    });
  }

  disconnect() { }
}



// WEBPACK FOOTER //
// ./src/app/manage-group-dialog/manage-group-dialog.component.ts